import React, { useState } from "react";
import CopyIcon from "../Assets/svgs/CopyIcon";
import { Tooltip } from "@mui/material";
import { copyToClipboard } from "./utils";

const CopyTooltipIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [open, setOpen] = useState(false);

  const onClickCopy = () => {
    copyToClipboard(text);
    setIsCopied(true);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2000);
  };

  return (
    <Tooltip
      title={isCopied ? "Copied" : "Copy"}
      placement="top"
      arrow
      open={open}
    >
      <button className="btn" onClick={onClickCopy}>
        <CopyIcon />
      </button>
    </Tooltip>
  );
};

export default CopyTooltipIcon;
